import type { SVGProps } from 'react';
const DawnFlagCM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CM_svg__a)">
      <path fill="url(#dawn-flag-CM_svg__b)" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#059170" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#E21A30"
        fillRule="evenodd"
        d="M7.333 16h7.333V0H7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#FFDC44"
        fillRule="evenodd"
        d="M14.667 16H22V0h-7.333z"
        clipRule="evenodd"
      />
      <path
        fill="#FFDC42"
        fillRule="evenodd"
        d="m11 9.04-1.54 1.117.568-1.836L8.51 7.176l1.89-.017.6-1.826.601 1.826 1.89.017-1.519 1.145.568 1.836z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-CM_svg__b"
        x1={10.477}
        x2={10.477}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDC44" />
        <stop offset={1} stopColor="#FDD216" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagCM;
